import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { withProtectedRoute } from './hoc/withProtectedRoute';
import { withPublicRoute } from './hoc/withPublicRoute';
import MainLayout from './layout/MainLayout';
import AmarrePage from './pages/AmarrePage';
import DashboardPage from './pages/DashboardPage';
import EvaluacionPreguntaPage from './pages/EvaluacionPreguntaPage';
import EvaluacionesTrianualesPage from './pages/EvaluacionesTrianualesPage';
import InformePreviewPage from './pages/InformePreviewPage';
import ListadoEvaluacionesPage from './pages/ListadoEvaluacionesPage';
import LoginPage from './pages/LoginPage';
import ReportesPage from './pages/ReportesPage';
import ToolboxCargaPage from './pages/ToolboxCargaPage';
import ToolboxPage from './pages/ToolboxPage';
import VerificarOTPPage from './pages/VerificarOTPPage';
import { useAuthStore } from './store/authStore';

function LoginScreen() {
  return (
    <MainLayout>
      <LoginPage />
    </MainLayout>
  );
}

function VerificarOTPScreen() {
  return (
    <MainLayout>
      <VerificarOTPPage />
    </MainLayout>
  );
}

function DashboardScreen() {
  return (
    <MainLayout>
      <DashboardPage />
    </MainLayout>
  );
}

function AmarreScreen() {
  return (
    <MainLayout>
      <AmarrePage />
    </MainLayout>
  );
}

function EvaluacionesTrianualesScreen() {
  return (
    <MainLayout>
      <EvaluacionesTrianualesPage />
    </MainLayout>
  );
}

function ListadoEvaluacionesScreen() {
  return (
    <MainLayout>
      <ListadoEvaluacionesPage />
    </MainLayout>
  );
}

function EvaluacionPreguntaScreen() {
  return (
    <MainLayout>
      <EvaluacionPreguntaPage />
    </MainLayout>
  );
}

function ReportesScreen() {
  return (
    <MainLayout>
      <ReportesPage />
    </MainLayout>
  );
}

function InformePreviewScreen() {
  return (
    <MainLayout>
      <InformePreviewPage />
    </MainLayout>
  );
}

function ToolboxScreen() {
  return (
    <MainLayout>
      <ToolboxPage />
    </MainLayout>
  );
}

function ToolboxCargaScreen() {
  return (
    <MainLayout>
      <ToolboxCargaPage />
    </MainLayout>
  );
}

const PublicLoginScreen = withPublicRoute(LoginScreen);
const PublicVerificarOTPScreen = withPublicRoute(VerificarOTPScreen);
const ProtectedDashboardScreen = withProtectedRoute(DashboardScreen);
const ProtectedAmarreScreen = withProtectedRoute(AmarreScreen);
const ProtectedEvaluacionesTrianualesScreen = withProtectedRoute(
  EvaluacionesTrianualesScreen
);
const ProtectedListadoEvaluacionesScreen = withProtectedRoute(
  ListadoEvaluacionesScreen
);
const ProtectedEvaluacionPreguntaScreen = withProtectedRoute(
  EvaluacionPreguntaScreen
);
const ProtectedReportesScreen = withProtectedRoute(ReportesScreen);
const ProtectedInformePreviewScreen = withProtectedRoute(InformePreviewScreen);
const ProtectedToolboxScreen = withProtectedRoute(ToolboxScreen);
const ProtectedToolboxCargaScreen = withProtectedRoute(ToolboxCargaScreen);

function HomeRedirect() {
  const hasHydrated = useAuthStore((state) => state.hasHydrated);
  const isAuthenticated = useAuthStore((state) => Boolean(state.session));

  if (!hasHydrated) {
    return <MainLayout />;
  }

  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/login" element={<PublicLoginScreen />} />
        <Route path="/login/verificar" element={<PublicVerificarOTPScreen />} />
        <Route path="/dashboard" element={<ProtectedDashboardScreen />} />
        <Route path="/amarre" element={<ProtectedAmarreScreen />} />
        <Route
          path="/evaluaciones-trianuales"
          element={<ProtectedEvaluacionesTrianualesScreen />}
        />
        <Route
          path="/evaluaciones-trianuales/listado"
          element={<ProtectedListadoEvaluacionesScreen />}
        />
        <Route
          path="/evaluaciones-trianuales/preguntas/:preguntaId"
          element={<ProtectedEvaluacionPreguntaScreen />}
        />
        <Route
          path="/amarre/preguntas/:preguntaId"
          element={<ProtectedEvaluacionPreguntaScreen />}
        />
        <Route
          path="/evaluaciones-trianuales/informe/:tipo/:informeId"
          element={<ProtectedInformePreviewScreen />}
        />
        <Route
          path="/evaluaciones-trianuales/informe/:evaluacionId"
          element={<ProtectedInformePreviewScreen />}
        />
        <Route path="/reportes" element={<ProtectedReportesScreen />} />
        <Route path="/toolbox" element={<ProtectedToolboxScreen />} />
        <Route path="/toolbox/carga" element={<ProtectedToolboxCargaScreen />} />
        <Route path="*" element={<HomeRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
